// extracted by mini-css-extract-plugin
export default {"page":"W93lu","inner":"L7Xhq","toolbar":"UJvaQ","actions":"IaDGC"};